import {
    BUTTON_SIZE,
    BUTTON_TYPE,
    TEXT_SIZES,
} from '@helpers/constants'
import Button from '@components/Button'
import Text from '@components/Text'
import BlockRenderer from '@views/BlockRenderer'

const EditExerciseBlock = ({ type, onPressEdit, name }) => {
    return (
        <div className={'flex justify-between items-center bg-lightGrey border border-mediumGrey rounded-sm p-4 my-2'}>
            <div className={'flex flex-col'}>
                {name ?
                    <BlockRenderer content={name} />
                :
                    <Text size={TEXT_SIZES.XSMALL} bold italic>{'Övningen har inget namn'}</Text>
                }
                <Text size={TEXT_SIZES.XSMALL}>{type}</Text>
            </div>

            <Button
                type={BUTTON_TYPE.PRIMARY}
                size={BUTTON_SIZE.LARGE}
                handleClick={onPressEdit}
            >
                Redigera
            </Button>
        </div>
    )
}

export default EditExerciseBlock